﻿import { required } from 'vuelidate/lib/validators';
import { mapGetters, mapState } from 'vuex';

const dropdownListCheck = value => {
	if (typeof value === 'undefined' || value === null || value === '' || value === '-') {
		return false;
	}
	return true;
}

export default {
    name: 'employment-and-accomodation',
    mounted() {
        this.$watch('$v.model.$invalid',
            () => {
                this.updateValidState();
            });
        this.updateValidState();
        this.model = this.viewmodel;
        if (this.model.clientRefresh) {
            this.$v.model.$touch();
        }
    },
    props: ['viewmodel', 'blockid'],
    data: () => ({
        model: {
            employmentStatus: "",
            accomodationType: "",
            clientRefresh: false
        },
        showShippingAddressModal: false,
    }),
    validations: {
    	model: {
    		employmentStatus: {
    			required,
				dropdownListCheck
    		},
    		accomodationType: {
    			required,
				dropdownListCheck
    		}
    	}
    },
    methods:{
        updateValidState(){
            this.$store.dispatch('updateValidState', {invalid: this.$v.model.$invalid, blockId: this.blockid});   
        }
    }
}
